<template>
  <v-row
    v-if="shouldShow"
    align="center"
    no-gutters
    class="my-5"
  >
    <v-divider />
    <v-btn
      class="mx-4 text-caption text-uppercase"
      small
      color="primary"
      @click="onAdd"
    >
      <v-icon class="mr-2">
        add
      </v-icon>
      Add {{ section }}
    </v-btn>
    <v-divider />
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

export default {
  name: 'SectionAdderLine',

  props: {
    hasNewSection: {
      type: Boolean,
      required: true,
    },

    section: {
      type: String,
      required: true,
    },
  },

  computed: {
    shouldShow () {
      return !this.hasNewSection &&
        !this.peGenericSectionLoading &&
        this.peUserCanUpdate === true
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peGenericSectionLoading',
      'peUserCanUpdate',
    ]),
  },

  methods: {
    onAdd () {
      this.$emit('on-add', {})
    },
  },
}
</script>
